<template>
  <!-- 看板背景，动态粒子效果 -->
  <div class="board-background" ref="bgContainer">
    <canvas class="canvas1" ref="bgCanvas"/>
    <div class="title-container" ref="titleContainer">
      <canvas class="canvas2" ref="titleCanvas"/>
      <div class="logo"><slot name="logo"/></div>
      <div class="title"><slot/></div>
      <div class="info"><slot name="info"/></div>
    </div>
  </div>
</template>

<script>

import canvasUtil from "@/util/canvasUtil";

export default {
  props: {
    // 颜色，使用rgb格式，但不需要加标识，而是使用逗号分隔
    color: {default: "0,0,0"},
    lineColor: {default: "#22ffed"}, // 线条颜色
    stockColor: {default: "rgba(24,255,237,.3)"}, // 区块颜色
    // 粒子移动的速度,这个速度值为正负值，必须是偶数，2表示速度为1
    speed: {default: 2},
    // 这个数量越大，粒子总数越少
    density: {default: 25000},
    // 连接线的长度，超过这个距离将会断开连接，这个长度为平方数
    lineLength: {default: 20000},
    showHeader: {default: true},
  },
  name: "RBG",
  components: {
  },
  data() {
    return {
      particlesArray: [],
      canvas: null,
      ctx: null,
      hue: 0,
    };
  },
  created() {
  },
  mounted() {
    // 获取canvas对象
    this.canvas = this.$refs.bgCanvas;
    this.ctx = this.canvas.getContext('2d');
    this.windowResize();
    // 处理窗口大小变化
    window.addEventListener('resize', this.windowResize);
    this.animate();
    if (this.showHeader) {
      this.drawTitleLine(); // 添加title行的线条
    }
  },
  unmounted() {
    // 移除这个操作
    window.removeEventListener("resize", this.windowResize);
  },
  methods: {
    drawTitleLine() {
      let container = this.$refs.titleContainer;
      let canvas = this.$refs.titleCanvas;
      canvas.width = container.clientWidth;
      canvas.height = container.clientHeight;
      let width = container.clientWidth;
      let subWidth = width / 9;
      let height = container.clientHeight;
      let ctx = canvas.getContext('2d');
      this.$nextTick().then(() => {
        ctx.clearRect(0,0,width, height); // 清空图形
        let arr = [
          [0, height - 10],
          [subWidth, height - 10],
          [subWidth + 20, height - 15],
          [subWidth * 3, height - 15],
          [subWidth * 3 + 5, height - 8],
          [subWidth * 3 + 10, height - 8],
          [subWidth * 3 + 12, height - 3],
          [subWidth * 6 - 12, height - 3],
          [subWidth * 6 - 10, height - 8],
          [subWidth * 6 - 5, height - 8],
          [subWidth * 6, height - 15],
          [subWidth * 8 - 20, height - 15],
          [subWidth * 8, height - 10],
          [width, height - 10],
        ];
        canvasUtil.drawPolyline(ctx, arr, 2, this.lineColor);
        // 线条列表
        let lineList = [
          [[subWidth + 60, height - 22], [subWidth * 3 - 110, height - 22]], // 左边长线
          [[subWidth + 10, height - 22], [subWidth + 17, height - 22]],
          [[subWidth + 20, height - 22], [subWidth + 27, height - 22]],
          [[subWidth + 30, height - 22], [subWidth + 37, height - 22]],
          [[subWidth + 40, height - 22], [subWidth + 47, height - 22]],
          [[subWidth + 50, height - 22], [subWidth + 57, height - 22]],
          [[subWidth * 2, 10], [subWidth * 3 - 100, 10]], // 左上长线
          [[subWidth * 3 - 97, 10], [subWidth * 3 - 90, 10]],
          [[subWidth * 3 - 87, 10], [subWidth * 3 - 80, 10]],
          [[subWidth * 3 - 77, 10], [subWidth * 3 - 70, 10]],
          [[subWidth * 3 - 67, 10], [subWidth * 3 - 60, 10]],

          [[subWidth * 8 - 60, height - 22], [subWidth * 6 + 110, height - 22]], // 左边长线
          [[subWidth * 8 - 10, height - 22], [subWidth * 8 - 17, height - 22]],
          [[subWidth * 8 - 20, height - 22], [subWidth * 8 - 27, height - 22]],
          [[subWidth * 8 - 30, height - 22], [subWidth * 8 - 37, height - 22]],
          [[subWidth * 8 - 40, height - 22], [subWidth * 8 - 47, height - 22]],
          [[subWidth * 8 - 50, height - 22], [subWidth * 8 - 57, height - 22]],
          [[subWidth * 7, 10], [subWidth * 6 + 100, 10]], // 左上长线
          [[subWidth * 6 + 97, 10], [subWidth * 6 + 90, 10]],
          [[subWidth * 6 + 87, 10], [subWidth * 6 + 80, 10]],
          [[subWidth * 6 + 77, 10], [subWidth * 6 + 70, 10]],
          [[subWidth * 6 + 67, 10], [subWidth * 6 + 60, 10]],

        ];
        // 装饰线条
        for (let i = 0; i < lineList.length; i++) {
          canvasUtil.drawPolyline(ctx, lineList[i], 3, this.lineColor);
        }
        // 绘制多边形
        let polygon = [
          [10, 10],
          [subWidth * 2 - 5, 10],
          [subWidth * 2, 15],
          [subWidth * 3 - 30, 15],
          [subWidth * 3, height - 22],
          [subWidth * 3 - 100, height - 22],
          [subWidth * 3 - 105, height - 27],
          [subWidth + 5, height - 27],
          [subWidth, height - 22],
          [50, height - 22]];
        canvasUtil.drawPolygon(ctx, polygon, this.lineColor, this.stockColor); // 左边的多边形
        canvasUtil.drawPolygon(ctx, [[10, 18], [45, height - 22], [10, height - 22]], this.lineColor, this.stockColor); // 左边的三角形
        let polygon2 = [
            [width - 10, 10],
            [subWidth * 7 + 5, 10],
            [subWidth * 7, 15],
            [subWidth * 6 + 30, 15],
            [subWidth * 6, height - 22],
            [subWidth * 6 + 100, height - 22],
            [subWidth * 6 + 105, height - 27],
            [subWidth * 8 - 5, height - 27],
            [subWidth * 8, height - 22],
            [width - 50, height - 22],
        ];
        canvasUtil.drawPolygon(ctx, polygon2, this.lineColor, this.stockColor); // 右边的多边形
        canvasUtil.drawPolygon(ctx, [[width - 10, 18], [width - 45, height - 22], [width - 10, height - 22]], this.lineColor, this.stockColor); // 右边的三角形
      });
    },

    // 窗口变化时，重置
    windowResize() {
      // 容器
      let container = this.$refs.bgContainer;
      this.canvas.width = container.clientWidth;
      this.canvas.height = container.clientHeight;
      this.init();
    },
    // 绘制单个粒子
    draw(pax) {
      this.ctx.beginPath();
      this.ctx.arc(pax.x, pax.y, pax.size, 0, Math.PI * 2, false);
      this.ctx.fillStyle = pax.color; // 粒子核心为白色
      this.ctx.fill();
    },
    // 更新粒子位置及状态
    update(pax) {
      // 边界检测：碰到屏幕边缘反弹
      if (pax.x > this.canvas.width || pax.x < 0) {
        pax.directionX = -pax.directionX;
      }
      if (pax.y > this.canvas.height || pax.y < 0) {
        pax.directionY = -pax.directionY;
      }
      // 移动粒子
      pax.x += pax.directionX;
      pax.y += pax.directionY;
      // 绘制
      this.draw(pax);
    },
    // 初始化粒子数组
    init() {
      this.particlesArray = [];
      // 根据屏幕面积计算粒子数量，保证密度适中
      let numberOfParticles = (this.canvas.height * this.canvas.width) / this.density;

      for (let i = 0; i < numberOfParticles; i++) {
        // let size = (Math.random() * 2) + 1; // 粒子大小 1-3
        let size = Math.random() + 1; // 粒子大小 1-2
        let x = (Math.random() * ((innerWidth - size * 2) - (size * 2)) + size * 2);
        let y = (Math.random() * ((innerHeight - size * 2) - (size * 2)) + size * 2);
        let directionX = (Math.random() * this.speed) - (this.speed / 2); // 速度
        let directionY = (Math.random() * this.speed) - (this.speed / 2);
        this.particlesArray.push({x, y, directionX, directionY, size, color: this.lineColor});
      }
    },
    // 连接粒子的连线效果
    connect() {
      let opacityValue = 1;
      // hex颜色转rgb颜色
      let hex = this.lineColor.replace("#", "");
      let h1 = hex.substring(0, 2), h2 = hex.substring(2,4), h3 = hex.substring(4, 6);
      let rgb = `${parseInt(h1, 16)},${parseInt(h2, 16)},${parseInt(h3, 16)}`;

      for (let a = 0; a < this.particlesArray.length; a++) {
        for (let b = a; b < this.particlesArray.length; b++) {
          let distance = ((this.particlesArray[a].x - this.particlesArray[b].x) * (this.particlesArray[a].x - this.particlesArray[b].x))
              + ((this.particlesArray[a].y - this.particlesArray[b].y) * (this.particlesArray[a].y - this.particlesArray[b].y));

          // 如果两个粒子距离小于一定值，则画线
          // if (distance < (this.canvas.width/7) * (this.canvas.height/7)) {
          if (distance < this.lineLength) {
            opacityValue = 1 - (distance / this.lineLength * 2); // 超过一半时显示为半透明

            // 动态颜色：基于 Hue 变量实现彩虹渐变效果
            // this.ctx.strokeStyle = `hsla(${this.hue}, 100%, 50%, ${opacityValue})`;

            this.ctx.strokeStyle = `rgba(${rgb}, ${opacityValue})`;
            this.ctx.lineWidth = 1;
            this.ctx.beginPath();
            this.ctx.moveTo(this.particlesArray[a].x, this.particlesArray[a].y);
            this.ctx.lineTo(this.particlesArray[b].x, this.particlesArray[b].y);
            this.ctx.stroke();
          }
        }
      }
    },
    // 动画循环
    animate() {
      requestAnimationFrame(this.animate); // 浏览器在下一次动画前，会调用这个回调
      // 每一帧清除画布，保留一点拖尾效果可以将 clearRect 改为 fillRect 并设置低透明度
      this.ctx.clearRect(0, 0, innerWidth, innerHeight);
      // 更新所有粒子
      for (let i = 0; i < this.particlesArray.length; i++) {
        this.update(this.particlesArray[i]);
      }
      // 绘制连线
      this.connect();
      // 颜色循环变化
      this.hue += 0.5;
      if (this.hue > 360){
        this.hue = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.board-background{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  .canvas1 {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    opacity: .7;
  }
  .title-container {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo{
      width: 30%;
      z-index: 1;
    }
    .title{
      height: 100px;
      font-size: 42px;
      font-weight: 900;
      letter-spacing: 10px;
      line-height: 80px;
      width: 100px;
      flex: 1;
      text-align: center;
      color: #FFF;
      z-index: 1;
      //background-image: linear-gradient(to top, #1a46f7 , #22f7ff );
      //background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
    .info{
      width: 30%;
      text-align: right;
      z-index: 1;
    }
    .canvas2 {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

</style>